var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-projects-invoices mp-sections"},[_c(_setup.InvoicesActions),_c(_setup.InvoicesCurrent),_c(_setup.InvoicesIncoming),_c(_setup.InvoicesOutgoing)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }